import type { BlogPost } from '@kkf/design'
import { blogGridCards } from '@kkf/design'
import { POSTS as PARSED } from 'virtual:blog-posts'

/**
 * The Foundation's view of the blog.
 *
 * **The blog is one library on four sites as of 2026-09-21.** The markdown is
 * `content/blog/*.md` at the repository root, beside `assets/media/` and for the same
 * reason: four copies of a post are four posts that drift. `tools/vite-blog.ts` reads,
 * front-matter-parses and schema-validates it in Node at build time and serves the result
 * through `virtual:blog-posts`, so the content ships in git and deploys with the app —
 * there is no CMS, no database and no API, and nothing is fetched at runtime.
 *
 * **This app takes every post**, because the Foundation is the whole of the work and its
 * blog is the whole of the blog. The three ventures filter by tag in their own
 * `vite.config.ts`; this one passes no `tags`. See `blogContent` for why an app that
 * matches nothing gets an empty list rather than an error.
 *
 * Everything that used to be derived here — the cards, the metas, the sidebar, the slug
 * lookup — is in `@kkf/design`'s `blog/posts.ts` now, because four apps do it.
 */
if (PARSED.length === 0) throw new Error('No posts found in content/blog/*.md')

export const POSTS = PARSED as BlogPost[]

/** The home page's blog band shows them as grid cards. */
export const BLOG_POSTS_HOME = blogGridCards(POSTS)
